/* eslint-disable no-unused-vars */
/* ICONS */
import { MdEmail , MdOutlineInventory2 } from "react-icons/md";
import { IoHeadsetOutline } from "react-icons/io5";
import { FaRegMessage } from "react-icons/fa6";
const navMenu = [
  {
    id: 1,
    link: "/contact-us",
    icon: IoHeadsetOutline,
    name: "Contact Us",
  },
  
 
];

export default navMenu;
